var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_27392)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.63346 5.86671C7.44781 5.86671 7.26976 5.79296 7.13849 5.66168C7.00721 5.53041 6.93346 5.35236 6.93346 5.16671C6.93346 4.98106 7.00721 4.80301 7.13849 4.67173C7.26976 4.54046 7.44781 4.46671 7.63346 4.46671C7.81912 4.46671 7.99716 4.54046 8.12844 4.67173C8.25971 4.80301 8.33346 4.98106 8.33346 5.16671C8.33346 5.35236 8.25971 5.53041 8.12844 5.66168C7.99716 5.79296 7.81912 5.86671 7.63346 5.86671ZM8.2168 10.2038C8.2168 10.3585 8.15534 10.5069 8.04594 10.6163C7.93655 10.7257 7.78817 10.7871 7.63346 10.7871C7.47875 10.7871 7.33038 10.7257 7.22098 10.6163C7.11159 10.5069 7.05013 10.3585 7.05013 10.2038V7.28712C7.05013 7.13241 7.11159 6.98404 7.22098 6.87465C7.33038 6.76525 7.47875 6.70379 7.63346 6.70379C7.78817 6.70379 7.93655 6.76525 8.04594 6.87465C8.15534 6.98404 8.2168 7.13241 8.2168 7.28712V10.2038ZM7.63346 1.08337C4.08971 1.08337 1.2168 3.95629 1.2168 7.50004C1.2168 11.0438 4.08971 13.9167 7.63346 13.9167C11.1772 13.9167 14.0501 11.0438 14.0501 7.50004C14.0501 3.95629 11.1772 1.08337 7.63346 1.08337Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_27392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.633789 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfo);
export default __webpack_public_path__ + "static/media/ic_info.cb8bd582236f2a7026877b201d3819d0.svg";
export { ForwardRef as ReactComponent };